import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import ModalTimeout from "./modalTimeout";


const Countdown = ({ initial = 1200 }) => { // 20 minutes
    const [time, setTime] = useState(initial);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (time === 0) {
            setOpen(true);
            return;
        }

        const interval = setInterval(() => {
            setTime((t) => t - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [time]);

    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
const reset= ()=>{
    setTime(initial)
    setOpen(false)
}
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #DCDCDC",
                    borderRadius: 50,
                    px: 2,
                    py: 1,
                }}
            >
                <Typography sx={{ color: "#004B88", fontWeight: 600 }}>
                    {minutes}:{seconds.toString().padStart(2, "0")}
                </Typography>
            </Box>

            <ModalTimeout open={open} onClose={() => {setOpen(false)}} reset={() => reset()} />
        </>
    );
};

export default Countdown;
